import * as React from 'react';
import { HTMLAttributes } from 'react';
import { Pdf, PdfProps } from './Pdf';
import { Image, ImageProps } from './Image';

export interface AssetProps {
    title?: string;
    description?: string;
    url: string;
    size: number;
    fileName: string;
    contentType: string;
}

const isImage = (contentType: string) => contentType.startsWith('image/');

const isPdf = (contentType: string) => contentType === 'application/pdf';

const childElement = (contentType: string, props: AssetProps) => {
    if (isImage(contentType)) {
        return <Image {...(props as ImageProps)}/>;
    } else if (isPdf(contentType)) {
        return <Pdf {...(props as PdfProps)}/>;
    } else {
        return null;
    }
};

export const Asset: React.FC<AssetProps & HTMLAttributes<HTMLDivElement>> = (props) => {
    const { contentType } = props;
    return childElement(contentType, props);
};


// WEBPACK FOOTER //
// ./src/asset/Asset.tsx